module.exports = __webpack_public_path__ + "static/media/greycircle.6c0a8ad4.svg";